import React from "react";
import imageList from "../artworks/imagelist.json";
import {Container} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import ImageGallery from "../components/ImageGallery";

const Artworks = () => {
    const images = imageList.map((item) => ({
        full: require("../artworks/" + item),
        name: item,
        thumbnail: require("../artwork_thumbnails/" + item + ".jpg")
    }));

    return (
        <>
            <div className={"artworks-container"}>
                <nav>
                    <ul>
                        <li><NavLink style={{color: '#fee4ee'}} to='/'>ARTWORKS</NavLink></li>
                        <li><NavLink to='/designs'>DESIGNS</NavLink></li>
                        <li><NavLink to='/about'>ABOUT</NavLink></li>
                    </ul>
                </nav>
                <Container>
                    <div className={"dropdown-shadow-artworks"}>
                        <ImageGallery images={images} label="Artwork" />
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Artworks;
